var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5009766,28c0.2285156,0,0.4589844-0.0537109,0.6708984-0.1582031l5.7226562-2.8623047 c0.3320312-0.1640625,0.6367188-0.3828125,0.90625-0.6513672L28.9365234,6.1914062C29.6220703,5.5068359,30,4.5957031,30,3.6259766 C30,1.6269531,28.3730469,0,26.3740234,0c-0.9697266,0-1.8808594,0.3779297-2.5644531,1.0625L5.6699219,19.2011719 c-0.2666016,0.2675781-0.4853516,0.5722656-0.6484375,0.9013672L2.15625,25.8330078 C2.0537109,26.0400391,2,26.2705078,2,26.4990234C2,27.3261719,2.6738281,28,3.5009766,28z M6.8115234,20.9941406 c0.0693359-0.1396484,0.1621094-0.2675781,0.2763672-0.3828125L25.2246094,2.4755859 C25.5302734,2.1689453,25.9394531,2,26.3740234,2C27.2705078,2,28,2.7294922,28,3.6259766 c0,0.4345703-0.1689453,0.84375-0.4765625,1.1503906L9.3886719,22.9121094 c-0.1152344,0.1142578-0.2431641,0.2070312-0.3857422,0.2773438l-4.3857422,2.1933594L6.8115234,20.9941406z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 30,
    width: 28,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSmall);
export default __webpack_public_path__ + "static/media/edit--small.5ac9719e701b61329239373c166d7af4.svg";
export { ForwardRef as ReactComponent };